export default __webpack_public_path__ + "static/media/approved_icon.48da170c.svg";